import React from 'react';
import { useFormik } from 'formik';
import { Grid } from '@mui/material';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import SecHeading from '../../../../constants/SecHeading';
import Container from '../../../../constants/Container';
import InputTextBox from '../../../../constants/InputTextBox';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import { handleChangeDate, handleSelectBox } from '../../../../helpers/handleChange';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { YesNoOptions } from '../../../../constants/Options';

interface FiscalAddFormViewProps {
    handleFormSuccess: () => void;
}
const FiscalYeaCreateView: React.FC<FiscalAddFormViewProps> = ({ handleFormSuccess }) => {
    const initialValues = {
        fiscal_year_name: "",
        from_date_n: "",
        to_date_n: "",
        is_current_fiscal: "",
        status: "",
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("fiscal_year_name", values.fiscal_year_name);
            formData.append("from_date_n", values.from_date_n);
            formData.append("to_date_n", values.to_date_n);
            formData.append("is_current_fiscal", values.is_current_fiscal=== "1" ? "1" : "0");
            formData.append("status", values.status=== "1" ? "1" : "0");
            try {
                await postDataToTheServer(AppURL.AccountURL + 'account/fiscal/year/create/list/view/', formData).then((res) => {
                    if (res?.status === 201) {
                        handleFormSuccess();
                        ToastSuccess({ message: res?.message });
                        action.resetForm();
                    } else if (res?.status === 400) {
                        ToastWarning({ message: res?.message });
                    }
                    else {
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Fiscal Year Add' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='fiscal_year_name'
                            label='Fiscal Year Name'
                            handleChange={handleChange}
                            value={values.fiscal_year_name}
                            error={errors.fiscal_year_name}
                            handleBlur={handleBlur}
                            touched={touched.fiscal_year_name}
                            required={true}
                            placeholder='2081-2082'
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='from_date_n'
                            label='From Fiscal Date(B.S.)'
                            handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'from_date_n' })}
                            value={values.from_date_n}
                            error={errors.from_date_n}
                            handleBlur={handleBlur}
                            touched={touched.from_date_n}
                            required={true}
                            placeholder='XXXX/XX/XX'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='to_date_n'
                            label='To Fiscal Date(B.S.)'
                            handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'to_date_n' })}
                            value={values.to_date_n}
                            error={errors.to_date_n}
                            handleBlur={handleBlur}
                            touched={touched.to_date_n}
                            required={true}
                            placeholder='XXXX/XX/XX'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label='Current Fiscal'
                            options={YesNoOptions}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            value={values.is_current_fiscal}
                            required={false}
                            placeholder='Select current fiscal'
                            name='is_current_fiscal'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'is_current_fiscal' } });
                            }}
                            touched={touched.is_current_fiscal}
                            errors={errors.is_current_fiscal}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label='Active'
                            options={YesNoOptions}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            value={values.status}
                            required={false}
                            placeholder='Select active status'
                            name='status'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'status' } });
                            }}
                            touched={touched.status}
                            errors={errors.status}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default FiscalYeaCreateView
